module.exports = __webpack_public_path__ + "static/img/mp3.6857d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/mp3.png
// module id = uHHb
// module chunks = 3